import React, { useState, useEffect } from "react";
import { Box, CircularProgress, Typography, Fade, Button } from "@mui/material";
import KuikwitLogo from "src/assets/images/auth/KuikwitLogo";
import useStyles from "./Styles";

interface BrandedLoaderProps {
  message?: string;
  showLogo?: boolean;
}

const BrandedLoader: React.FC<BrandedLoaderProps> = ({
  message,
  showLogo = true,
}) => {
  const { classes } = useStyles();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimedOut(true);
    }, 12000); // 12 seconds safety net

    return () => clearTimeout(timer);
  }, []);

  const handleRetry = () => {
    window.location.reload();
  };

  const handleCancel = () => {
    localStorage.removeItem("accessToken");
    window.location.href = "/login";
  };

  return (
    <Fade in timeout={500}>
      <Box className={classes.container}>
        <Box className={classes.logoWrapper}>
          <CircularProgress
            className={classes.spinner}
            thickness={2}
            size={80}
            sx={{ display: timedOut ? "none" : "block" }}
          />
          {showLogo && (
            <Box className={classes.logo}>
              <KuikwitLogo />
            </Box>
          )}
        </Box>

        {message && !timedOut && (
          <Typography className={classes.text}>{message}</Typography>
        )}

        {timedOut && (
          <Box className={classes.recoveryBox}>
            <Typography className={classes.recoveryText}>
              Taking longer than expected... please check your connection.
            </Typography>
            <Box className={classes.buttonGroup}>
              <Button
                variant="contained"
                className={classes.button}
                onClick={handleRetry}
              >
                Retry
              </Button>
              <Button
                variant="outlined"
                className={classes.button}
                sx={{ backgroundColor: "transparent", color: "#4D1277" }}
                onClick={handleCancel}
              >
                Back to Login
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Fade>
  );
};

export default BrandedLoader;
